import axios from 'axios'
import { useQuery, useQueryClient, useMutation } from 'react-query'

export const globalEventPurchaserLinkFetcher = async (body) => {
    const { data } = await axios.post('/purchaserlink', body)
    const parsedData = JSON.parse(data.jsonString)
    return parsedData.purchasers
}

export const useFetchPurchaserLink = (eventIDvalue) => {
    var body = {"eventid": eventIDvalue}
    return useQuery(
        ['purchaserlink', eventIDvalue],
        () => globalEventPurchaserLinkFetcher(body),
        {}
    )
}

export const usePutPurchaserLink = () => {
    const queryClient = useQueryClient()
    //console.log(" useputparticipant on query page")

    return useMutation((body: any) =>
        axios.put(`purchaserlink`, body), {
        onSuccess: () => {
            queryClient.invalidateQueries(['purchaserlink'])
        }
    })
}
//
// export const usePutPurchaserLink = (eventid: number, participantid: number) => {
//     // requires eventid: any, purchaserid: any
//     const queryClient = useQueryClient()
//
//     const body = {eventid: eventid, participantid: participantid}
//     axios.put(`purchaserlink`, body).then(response => {
//         queryClient.invalidateQueries(['purchaserlink'])
//     })
// }
export const usePutPurchaserUnLink = (eventid: number, participantid: number) => {
    // requires eventid: any, purchaserid: any
    const queryClient = useQueryClient()

    const body = {eventid: eventid, participantid: participantid}
    axios.put(`purchaserunlink`, body).then(response => {
        queryClient.invalidateQueries(['purchaserlink'])
    })
}

export const usePutPurchaserAutoLink = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) =>
        axios.post(`participantlinkauto`, body), {
        onSuccess: () => {
            queryClient.invalidateQueries(['linkingparticipant'])
        }
    })
}